import { render, staticRenderFns } from "./faculties-list.vue?vue&type=template&id=71e97901"
import script from "./faculties-list.vue?vue&type=script&lang=js"
export * from "./faculties-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports